import { monthlyFeePageFor } from "../monthlyFeePageFor";
import { TriggersMonthlyFeeItem } from "./TriggersMonthlyFeeItem";

export const TriggersMonthlyFees = monthlyFeePageFor(TriggersMonthlyFeeItem);
